<!-- 暂无数据 -->
<script>
	import noData from '../../assets/img/noData.png'
	export default {
		props: {
			text: {
				type: String,
				required: false,
				default: '暂无数据'
			}
		},
		render(createElement) {
			return createElement(
				'div', {
					'class': {
						'no-data': true,
					}
				},
				[
					createElement('img', {
						'class': {
							'nd': true
						},
						attrs: {
							src: noData
						}
					}),
					this.text,
					this.$slots.default
				]
			)
		}
	}
</script>

<style scoped lang="scss">
	.no-data {
		overflow: hidden;
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		text-align: center;
		color: rgba(2, 47, 74, 0.45);
		font-size: 14px;
		font-family: PingFang SC;

		img.nd {
			width: 225px;
			height: 160px;
			display: block;
			margin: 25px auto 15px auto;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/NoData.vue